module.exports = __webpack_public_path__ + "static/media/nagad-web-icon.f4e35452.svg";